export const categories = [
  {
    id: "all",
    label: "全部话题",
    desc: "站内收录的所有事件档案，按最近更新时间排序。",
    icon: "ri-layout-grid-line",
    tone: "secondary",
    count: 10,
  },
  {
    id: "entertainment",
    label: "娱乐动态",
    desc: "综艺、剧集、演出相关的讨论与后续回应。",
    icon: "ri-movie-2-line",
    tone: "primary",
    count: 2,
  },
  {
    id: "internet",
    label: "网络热点",
    desc: "平台机制、网络热梗与集体讨论的来龙去脉。",
    icon: "ri-fire-line",
    tone: "accent",
    count: 2,
  },
  {
    id: "brand",
    label: "品牌风波",
    desc: "产品标注、售后与消费体验引发的品牌讨论。",
    icon: "ri-store-2-line",
    tone: "secondary",
    count: 2,
  },
  {
    id: "tech",
    label: "科技圈",
    desc: "新技术落地过程中的争议、隐私与规则话题。",
    icon: "ri-cpu-line",
    tone: "primary",
    count: 2,
  },
  {
    id: "life",
    label: "生活话题",
    desc: "与日常出行、安全、消费相关的大众讨论。",
    icon: "ri-leaf-line",
    tone: "accent",
    count: 2,
  },
];